import React, { cloneElement, ElementType, isValidElement } from 'react'
import { ButtonProps, scales, variants } from './types'
import styled from 'styled-components'

const StyledButton = styled.button<{variant?: string}>`
  width: 100%;
  height: 55px;
  background: ${({variant}) => variant === 'outlined' 
          ? 'transparent'
          : 'linear-gradient(77.9deg, #0066FF -3.83%, #2CE0C5 110.36%)'
};
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  border: ${({variant}) => variant === 'outlined' ? '2px solid rgba(255, 255, 255, 0.15)' : 'none'};
  cursor:  pointer;
  
  &:hover {
    opacity: 0.8;
  }
`

const Button = <E extends ElementType = 'button'>(props: ButtonProps<E>): JSX.Element => {

  const {children, variant} = props

  return (
   <StyledButton variant={variant}>
     {children}
   </StyledButton>
  )
}

Button.defaultProps = {
  isLoading: false,
  external: false,
  variant: variants.PRIMARY,
  scale: scales.MD,
  disabled: false,
}

export default Button
